var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsModeComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mode_comment_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 14.6667L12 12H2.66667C2.3 12 1.98611 11.8694 1.725 11.6083C1.46389 11.3472 1.33333 11.0333 1.33333 10.6667V2.66667C1.33333 2.3 1.46389 1.98611 1.725 1.725C1.98611 1.46389 2.3 1.33333 2.66667 1.33333H13.3333C13.7 1.33333 14.0139 1.46389 14.275 1.725C14.5361 1.98611 14.6667 2.3 14.6667 2.66667V14.6667ZM2.66667 10.6667H12.5667L13.3333 11.4167V2.66667H2.66667V10.6667Z",
    fill: "#4C5E6E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsModeComment);
export default __webpack_public_path__ + "static/media/icons_mode_comment.cec43d0c.svg";
export { ForwardRef as ReactComponent };